import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TBSDashboard from './TBSDashboard';

// Every signed-in user lands on the same TBS Agentic Demo experience here —
// there's no per-user business data behind this route anymore. The auth
// guard below is what actually matters: it's what keeps an anonymous visit
// to /dashboard from hanging forever instead of bouncing to /login.
export default function Dashboard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate('/login', { replace: true });
  }, [user, loading, navigate]);

  if (loading || !user) {
    return (
      <div className="min-h-screen bg-[#050506] text-white flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-[#2E6BFF] rounded-full animate-spin" />
      </div>
    );
  }

  return <TBSDashboard />;
}
